/** Ilse's creator page: the example every "See a creator page" link on /creators opens. A plain link, not a router one: the route is its own page. */
export const CREATOR_PAGE_PATH = "/c/ilseandreajansen";
